import * as React from "react";

import Iconify from "../../iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import { useSelector } from "react-redux";
import { logout } from "@/src/lib/store/user-details/slice";
import { headerApiService } from "@/src/lib/api-services/headerApiServices";
import { useToast } from "@/src/lib/hooks/useToast";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import { useHODMutation } from "@/src/lib/hooks/useHODMutation";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import CustomIconButton from "@/src/lib/ui/iconButton";
import Image from "next/image";
import { Menu, MenuItem } from "@/src/lib/ui/customDropdownMenu";
import { useState } from "react";
export default function AccountMenu() {
    const router = useRouter();
    const userDetails = useSelector((state) => state?.user?.userInfo);
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const { showCustomToast } = useToast();
    const dispatch = useDispatch();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAnchorEl(null);
    };

    const myFamilyMembers = () => {
        router.push("/my-account/members");
    };
    const myOrders = () => {
        router.push("/my-account/my-orders");
    };

    const logoutMutation = useHODMutation(
        (data) => headerApiService.logout(data),
        {
            onSuccess: (data) => {
                dispatch(logout());
                showCustomToast(data?.message, "success");
                handleClose();
                router.push("/");
            },
            onError: (error) => {
                showCustomToast(error?.response?.data?.message, "error");
            },
        }
    );

    const logoutHandler = () => {
        logoutMutation.mutate();
    };

    return (
        <React.Fragment>
            <div className="flex items-center text-center relative">
                <CustomTooltip title="Account settings">
                    <CustomIconButton
                        onClick={(e) => handleClick(e)}
                        size="small"
                        className="cursor-pointer"
                    >
                        <Image
                            className="w-9 h-9"
                            src={`${NEXT_IMAGE_CDN}/web/common/icon/user-gold.png`}
                            alt="user"
                            width={10}
                            height={10}
                        />
                    </CustomIconButton>
                </CustomTooltip>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem onClick={handleClose} className="font-medium">
                        <Iconify
                            icon={IconCode.userProfile}
                            width={20}
                            className="mr-3"
                        />
                        <div className="font-medium whitespace-nowrap">
                            {`Hi, ${userDetails?.mobileNo}`}{" "}
                        </div>
                    </MenuItem>
                    <MenuItem onClick={myFamilyMembers} className="font-medium">
                        <Iconify
                            icon={IconCode.userIcon}
                            width={20}
                            className="mr-3"
                        />
                        Profile
                    </MenuItem>
                    <MenuItem onClick={myOrders} className="font-medium">
                        <Iconify
                            icon={IconCode.accountSetting}
                            width={20}
                            className="mr-3"
                        />
                        My Account
                    </MenuItem>

                    <MenuItem onClick={logoutHandler} className="font-medium">
                        <Iconify
                            icon={IconCode.logout}
                            width={20}
                            className="mr-3"
                        />
                        Logout
                    </MenuItem>
                </Menu>
            </div>
        </React.Fragment>
    );
}
